import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGithub,
	faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Works from "../components/homepage/works";
import ProjectList from "../components/projects/projectList";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/homepage.css";

const Homepage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "home");

	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						{/* <Logo width={logoSize} link={false} /> */}
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div className="title homepage-title">
									{INFO.homepage.title}
								</div>

								<div className="homepage-subtitle">
									{INFO.homepage.description}
								</div>

								<div className="homepage-button-container">
									<a
										href={INFO.main.bestSkills}
										target="_blank"
										rel="noreferrer"
									>
										<div className="homepage-button">
											{INFO.homepage.buttonsText}
										</div>
									</a>
								</div>
							</div>
						</div>

						<div className="homepage-socials">
							<a
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
								aria-label="GitHub"
							>
								<FontAwesomeIcon
									icon={faGithub}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
								aria-label="LinkedIn"
							>
								<FontAwesomeIcon
									icon={faLinkedin}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={`mailto:${INFO.main.email}`}
								target="_blank"
								rel="noreferrer"
								aria-label="Email"
							>
								<FontAwesomeIcon
									icon={faMailBulk}
									className="homepage-social-icon"
								/>
							</a>
						</div>

						<div className="homepage-projects">
							<ProjectList />
						</div>

						<div className="homepage-after-title">
							<div className="homepage-works">
								<Works data={INFO.works} />
							</div>
						</div>

						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>

				{/* {showScrollTop && (
					<button
						className="scroll-to-top"
						onClick={scrollToTop}
						aria-label="Scroll to top"
					>
						<FontAwesomeIcon icon={faArrowUp} />
					</button>
				)} */}
			</div>
		</React.Fragment>
	);
};

export default Homepage;
